"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeFuncs = composeFuncs;
exports.generateId = generateId;
exports.getOwnerDocument = getOwnerDocument;
exports.useForceUpdate = useForceUpdate;
exports.usePrevious = usePrevious;
var _react = _interopRequireWildcard(require("react"));
var _canUseDom = _interopRequireDefault(require("@ux/component-utilities/can-use-dom"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Generate an HTMLElement ID using a root value with segments
 *
 * @param {string} value root value of id
 * @param  {...string} segments additional id segments
 * @returns {string} HTMLElement ID
 */
function generateId(value) {
  const valueSlug = String(value).toLowerCase().replace(/[^a-z0-9-]+/g, '');
  for (var _len = arguments.length, segments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    segments[_key - 1] = arguments[_key];
  }
  return [valueSlug, ...segments].join('--');
}
function composeFuncs() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return fns.forEach(fn => fn && fn(...args));
  };
}

/**
 * Get an element's owner document. Useful when components are used in iframes
 * or other environments like dev tools.
 *
 * @param {HTMLElement} element element used to find parent
 * @returns {HTMLElement|null} owner document
 */
function getOwnerDocument(element) {
  if ((0, _canUseDom.default)()) {
    return element ? element.ownerDocument : document;
  }
  return null;
}

/**
 * Forces the containing component to perform an update lifecyle
 *
 * @returns {function} memoized callback
 */
function useForceUpdate() {
  const [, dispatch] = (0, _react.useState)(Object.create(null));
  return (0, _react.useCallback)(() => {
    dispatch(Object.create(null));
  }, []);
}

/**
 * Returns the previous value of a reference after a component update.
 *
 * @param {any} value next value
 * @returns {MutableRefObject} ref value
 */
function usePrevious(value) {
  const ref = _react.default.useRef(null);
  _react.default.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}